const initAuthorsForQuote = {
    init: function() {
        let quoteAuthorElements = document.getElementsByClassName('js-quote-author');
        var authors = document.getElementsByClassName('js-authors');
        if (quoteAuthorElements && quoteAuthorElements.length > 0 && authors && authors.length > 0) {
            for (var i = 0; i < quoteAuthorElements.length; i++) {
                if (authors[i]) {
                    quoteAuthorElements[i].innerHTML = authors[i].innerHTML;
                    quoteAuthorElements[i].style.display = "flex !important";
                }
            }
        }    }
}

initAuthorsForQuote.init();